var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price-feature"},[(_vm.variant.price)?_c('price-block',{class:['has-text-weight-bold', 'has-text-price', ("is-size-" + _vm.size)],attrs:{"currency":_vm.variant.priceCurrency,"price":_vm.variant.price}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }